import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  key: 0,
  className: "search-box",
  ref: "rootSearchWrapper"
};
const _hoisted_2 = {
  key: 0,
  class: "search-box__notification",
  role: "alert"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "searchbox_container"
};
const _hoisted_5 = ["disabled", "data-selection-full", "aria-label"];
const _hoisted_6 = {
  key: 1,
  class: "divider"
};
const _hoisted_7 = {
  key: 1,
  class: "search_result_list"
};
const _hoisted_8 = ["id", "onClick", "onKeydown", "innerHTML"];
const _hoisted_9 = {
  key: 2,
  class: "search_result_pdpurllist",
  style: {
    "display": "none"
  }
};
const _hoisted_10 = ["id", "onClick", "onKeydown", "innerHTML"];
const _hoisted_11 = ["id", "innerHTML"];
const _hoisted_12 = {
  key: 3,
  class: "search-box__selected-count",
  "aria-live": "polite"
};
const _hoisted_13 = {
  key: 4,
  class: "search-box__selected-products"
};
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = {
  class: "search-box__pill-source"
};
const _hoisted_16 = {
  key: 0,
  class: "search-box__pill-tech-content"
};
const _hoisted_17 = ["aria-label", "onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CloseIcon = _resolveComponent("CloseIcon");
  const _component_SearchIcon = _resolveComponent("SearchIcon");
  return _openBlock(), _createBlock(_Teleport, {
    to: "[aem-forms-search-box]"
  }, [$options.state ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.useV2Features && _ctx.blockingNotifications.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blockingNotifications, (notification, index) => {
    return _openBlock(), _createElementBlock("span", {
      key: index,
      innerHTML: notification
    }, null, 8, _hoisted_3);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
    maxlength: "190",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.inputValue = $event),
    onKeydown: [_cache[1] || (_cache[1] = _withKeys($event => $options.submit(), ["enter"])), _cache[2] || (_cache[2] = $event => $options.selectSearchResults($event))],
    onFocusout: _cache[3] || (_cache[3] = $event => $options.hideSearchResults($event)),
    class: "searchbox_input",
    disabled: $options.isSelectionFull,
    "data-selection-full": $options.isSelectionFull,
    "aria-label": $options.searchLabel,
    ref: "searchboxInputRef"
  }, null, 40, _hoisted_5), [[_vModelText, _ctx.inputValue]]), _ctx.inputValue.length ? (_openBlock(), _createBlock(_component_CloseIcon, {
    key: 0,
    class: "search__close",
    tabindex: "0",
    type: "button",
    onClick: $options.clearSearchTerm,
    "aria-label": "clear search"
  }, null, 8, ["onClick"])) : _createCommentVNode("", true), _ctx.inputValue.length ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : _createCommentVNode("", true), _createVNode(_component_SearchIcon, {
    class: "search__icon",
    tabindex: "0",
    type: "button",
    "aria-label": "submit search",
    onClick: $options.submit,
    onKeydown: [_cache[4] || (_cache[4] = _withKeys($event => $options.submit(), ["enter"])), _cache[5] || (_cache[5] = $event => $options.selectSearchResults($event))]
  }, null, 8, ["onClick"])]), !_ctx.blockingNotifications.length && (_ctx.searchResults && _ctx.searchResults.length > 0 || _ctx.useV2Features && _ctx.searchResponded) ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (result, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      id: 'searchResult' + index,
      class: "suggestion",
      tabindex: "0",
      onClick: $event => $options.selectSearchValue(result.rawValue),
      onKeydown: _withKeys($event => $options.selectSearchValue(result.rawValue), ["enter"]),
      innerHTML: result.rawValue
    }, null, 40, _hoisted_8);
  }), 128)), _ctx.useV2Features ? (_openBlock(), _createElementBlock("li", {
    key: 0,
    class: "suggestion search_result_add-anyway",
    tabindex: "0",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.addTypedProduct && $options.addTypedProduct(...args)),
    onKeydown: _cache[7] || (_cache[7] = _withKeys((...args) => $options.addTypedProduct && $options.addTypedProduct(...args), ["enter"]))
  }, " + " + _toDisplayString($options.cantFindProductLabel), 33)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $options.pdpUrlProducts && $options.pdpUrlProducts.length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.pdpUrlProducts, (result, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      id: 'searchResult' + index,
      class: "suggestion",
      tabindex: "0",
      onClick: $event => $options.selectSearchValue(result.rawValue),
      onKeydown: _withKeys($event => $options.selectSearchValue(result.rawValue), ["enter"]),
      innerHTML: result.rawValue
    }, null, 40, _hoisted_10);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.pdpUrlProducts, (result, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      id: 'searchResult' + index + 'pdpUrl',
      class: "suggestion",
      tabindex: "0",
      innerHTML: result.pdpUrl
    }, null, 8, _hoisted_11);
  }), 128))])) : _createCommentVNode("", true), _ctx.useV2Features && _ctx.selectedProducts.length > 0 ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString($options.selectedCountLabel), 1)) : _createCommentVNode("", true), _ctx.useV2Features && _ctx.selectedProducts.length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedProducts, product => {
    return _openBlock(), _createElementBlock("li", {
      key: product.rawValue,
      class: "search-box__pill"
    }, [_createElementVNode("span", {
      class: "search-box__pill-label",
      innerHTML: product.rawValue
    }, null, 8, _hoisted_14), _createElementVNode("span", _hoisted_15, _toDisplayString(product.pdpUrl ? $options.sourceSearchLabel : $options.sourceAutoLabel), 1), product.pdpUrl ? (_openBlock(), _createElementBlock("span", _hoisted_16, " ✓ " + _toDisplayString($options.techContentLabel), 1)) : _createCommentVNode("", true), _createElementVNode("button", {
      type: "button",
      class: "search-box__pill-remove",
      "aria-label": 'remove ' + product.rawValue,
      onClick: $event => $options.removeSelectedProduct(product)
    }, " × ", 8, _hoisted_17)]);
  }), 128))])) : _createCommentVNode("", true)], 512)) : _createCommentVNode("", true)]);
}